var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAspirantStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.189 4.51714L9.22178 3.94058L7.44834 0.345269C7.39991 0.246832 7.32022 0.167144 7.22178 0.118707C6.97491 -0.00316805 6.67491 0.0983945 6.55147 0.345269L4.77803 3.94058L0.810845 4.51714C0.70147 4.53277 0.60147 4.58433 0.524907 4.66246C0.432347 4.75759 0.381343 4.88558 0.383101 5.0183C0.384859 5.15103 0.439235 5.27762 0.534282 5.37027L3.40459 8.16871L2.72647 12.1203C2.71057 12.2122 2.72074 12.3067 2.75583 12.3932C2.79093 12.4796 2.84953 12.5545 2.92501 12.6093C3.00049 12.6641 3.08982 12.6967 3.18288 12.7033C3.27593 12.71 3.36898 12.6904 3.45147 12.6468L6.99991 10.7812L10.5483 12.6468C10.6452 12.6984 10.7577 12.7156 10.8655 12.6968C11.1374 12.65 11.3202 12.3921 11.2733 12.1203L10.5952 8.16871L13.4655 5.37027C13.5437 5.29371 13.5952 5.19371 13.6108 5.08433C13.653 4.81089 13.4624 4.55777 13.189 4.51714Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspirantStar);
export default __webpack_public_path__ + "static/media/aspirantStar.d43dbebc6f8bb6e4bc4ed90ef9f75939.svg";
export { ForwardRef as ReactComponent };